import React from 'react';
import { Link } from "react-router-dom";

const Courses = () => {
    return ( 
        <>
                            <section className="terms-items">
                        <header>
                            <h2 className="h2"> Last  Courses </h2>
                            <Link to="/allcourses"> All Courses </Link>
                        
                        </header>
                        <div className="row">
                       
                          
                          <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 term-col"
                         /*
                         ....##.....##....###....########.########.########..####....###....##...............##.....##.####
                         ....###...###...##.##......##....##.......##.....##..##....##.##...##...............##.....##..##.
                         ....####.####..##...##.....##....##.......##.....##..##...##...##..##...............##.....##..##.
                         ....##.###.##.##.....##....##....######...########...##..##.....##.##.......#######.##.....##..##.
                         ....##.....##.#########....##....##.......##...##....##..#########.##...............##.....##..##.
                         ....##.....##.##.....##....##....##.......##....##...##..##.....##.##...............##.....##..##.
                         ....##.....##.##.....##....##....########.##.....##.####.##.....##.########..........#######..####
                         */
                          >
                                <article>
                                    <a src="" className="img-layer cardImage">
                                        <img src="images/pic/mat.png" />
                                    </a>
                                    <h2>
                                        <a target="_blank" href="https://www.udemy.com/course/implement-high-fidelity-designs-with-material-ui-and-reactjs/">
                                            {" "}
                                        Material UI{" "}
                                        </a>
                                    </h2>
                                    <span className="myPrice">Free </span>
                                </article>
                            </div>


                            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 term-col"
                          /*
                          .......########..########....###.....######..########.......##..######.
                          .......##.....##.##.........##.##...##....##....##..........##.##....##
                          .......##.....##.##........##...##..##..........##..........##.##......
                          .......########..######...##.....##.##..........##..........##..######.
                          .......##...##...##.......#########.##..........##....##....##.......##
                          .......##....##..##.......##.....##.##....##....##....##....##.##....##
                          .......##.....##.########.##.....##..######.....##.....######...######.
                          */
                            >
                                <article>
                                    <a href="" className="img-layer">
                                        <img  src="images/pic/reactjs.png" />
                                    </a>
                                    <h2>
                                        <a target="_blank" href="https://www.udemy.com/course/react-the-complete-guide-incl-redux/">
                                            {" "}
                                        ReactJs{" "}
                                        </a>
                                    </h2>
                                    <span className="myPrice"> 299 $ </span>
                                </article>
                            </div>


                            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 term-col"
                          /*
                          .......########..########....###.....######..########....##....##....###....########.####.##.....##.########
                          .......##.....##.##.........##.##...##....##....##.......###...##...##.##......##.....##..##.....##.##......
                          .......##.....##.##........##...##..##..........##.......####..##..##...##.....##.....##..##.....##.##......
                          .......########..######...##.....##.##..........##.......##.##.##.##.....##....##.....##..##.....##.######..
                          .......##...##...##.......#########.##..........##.......##..####.#########....##.....##...##...##..##......
                          .......##....##..##.......##.....##.##....##....##.......##...###.##.....##....##.....##....##.##...##......
                          .......##.....##.########.##.....##..######.....##.......##....##.##.....##....##....####....###....########
                          */
                            >
                                <article>
                                    <a href="" className="img-layer">
                                        <img src="images/pic/reactn.jpeg" />
                                    </a>
                                    <h2>
                                        <a target="_blank" href="https://www.udemy.com/course/the-complete-react-native-and-redux-course/">
                                            {" "}
                                           React Native{" "}
                                        </a>
                                    </h2>
                                    <span className="myPrice"> 149 $ </span>
                                </article>
                            </div>


                            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 term-col"
                           /*
                           ..........##....###....##.....##....###.....######...######..########..####.########..########
                           ..........##...##.##...##.....##...##.##...##....##.##....##.##.....##..##..##.....##....##...
                           ..........##..##...##..##.....##..##...##..##.......##.......##.....##..##..##.....##....##...
                           ..........##.##.....##.##.....##.##.....##..######..##.......########...##..########.....##...
                           ....##....##.#########..##...##..#########.......##.##.......##...##....##..##...........##...
                           ....##....##.##.....##...##.##...##.....##.##....##.##....##.##....##...##..##...........##...
                           .....######..##.....##....###....##.....##..######...######..##.....##.####.##...........##...
                           */
                            >
                                <article>
                                    <a href="" className="img-layer">
                                        <img src="images/pic/JS.jpeg" />
                                    </a>
                                    <h2>
                                        <a target="_blank" href="https://www.udemy.com/course/the-complete-javascript-course/">
                                            {" "}
                                            JavaScript{" "}
                                        </a>
                                    </h2>
                                    <span className="myPrice"> 199 $</span>
                                </article>
                            </div>


                            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 term-col"
                           /*
                           ....########.##....##.########..########..######...######..########..####.########..########
                           .......##.....##..##..##.....##.##.......##....##.##....##.##.....##..##..##.....##....##...
                           .......##......####...##.....##.##.......##.......##.......##.....##..##..##.....##....##...
                           .......##.......##....########..######....######..##.......########...##..########.....##...
                           .......##.......##....##........##.............##.##.......##...##....##..##...........##...
                           .......##.......##....##........##.......##....##.##....##.##....##...##..##...........##...
                           .......##.......##....##........########..######...######..##.....##.####.##...........##...
                           */
                            >
                                <article>
                                    <a href="" className="img-layer">
                                        <img src="images/pic/ttt.jpg" />
                                    </a>
                                    <h2>
                                        <a target="_blank" href="https://www.udemy.com/course/understanding-typescript/">
                                            {" "}
                                           Typesript{" "}
                                        </a>
                                    </h2>
                                    <span className="myPrice"> 149 $ </span>
                                </article>
                            </div>
                            

                            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 term-col"
                          /*
                          .......##.....##..#######..##....##..######....#######..########..########.
                          .......###...###.##.....##.###...##.##....##..##.....##.##.....##.##.....##
                          .......####.####.##.....##.####..##.##........##.....##.##.....##.##.....##
                          .......##.###.##.##.....##.##.##.##.##...####.##.....##.##.....##.########.
                          .......##.....##.##.....##.##..####.##....##..##.....##.##.....##.##.....##
                          .......##.....##.##.....##.##...###.##....##..##.....##.##.....##.##.....##
                          .......##.....##..#######..##....##..######....#######..########..########.
                          */
                            >
                                <article>
                                    <a href="" className="img-layer">
                                        <img src="images/pic/mongodb.jpg" />
                                    </a>
                                    <h2>
                                        <a target="_blank"  href="https://www.udemy.com/course/mongodb-the-complete-developers-guide/">
                                            {" "}
                                           MongoDB{" "}
                                        </a>
                                    </h2>
                                    <span className="myPrice"> 149 $  </span>
                                </article>
                            </div>


                            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 term-col"
                           /*
                           ....##....##..#######..########..########..........##..######.
                           ....###...##.##.....##.##.....##.##................##.##....##
                           ....####..##.##.....##.##.....##.##................##.##......
                           ....##.##.##.##.....##.##.....##.######............##..######.
                           ....##..####.##.....##.##.....##.##..........##....##.......##
                           ....##...###.##.....##.##.....##.##..........##....##.##....##
                           ....##....##..#######..########..########.....######...######.
                           */
                            >
                                <article>
                                    <a href="" className="img-layer">
                                        <img src="images/pic/nodejs.png" />
                                    </a>
                                    <h2>
                                        <a target="_blank"  href="https://www.udemy.com/course/nodejs-the-complete-guide/">
                                            {" "}
                                            NodeJs{" "}
                                        </a>
                                    </h2>
                                    <span> 199$ USD </span>
                                </article>
                            </div>

                            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 term-col"
                            /*
                            .##.....##.########.########..##....##
                            .###...###.##.......##.....##.###...##
                            .####.####.##.......##.....##.####..##
                            .##.###.##.######...########..##.##.##
                            .##.....##.##.......##...##...##..####
                            .##.....##.##.......##....##..##...###
                            .##.....##.########.##.....##.##....##
                            */
                            >
                                <article>
                                    <a href="" className="img-layer">
                                        <img src="images/pic/mern.jpg" />
                                    </a>
                                    <h2>
                                        <a arget="_blank" href="https://www.udemy.com/course/mern-stack-front-to-back/">
                                            {" "}
                                            MERN{" "}
                                        </a>
                                    </h2>
                                    <span className="myPrice"> 399 $ </span>
                                </article>
                            </div>

                           
                        </div>
                    </section>
        </>
     );
}
 
export default Courses;